
// create the config file datas here
export const EVENTS = {
    
    // GENERAL APP INDIVIDUAL COURSE CATEGORY ITEMS
    TRENDING_EVENTS: [

        {
            "img": "/app_images/events/event1.webp",
            "link": "/app/events",
            "ticket_link": "https://www.askamaya.com/events/tickets",
            "badgeDate": "8 Jan",
            "badgeYear": "2024",
            "location": "Wembly",
            "time": "8:00 am - 5:00 pm",
            "title": "Elegant Light Box Paper Cut Dioramas",
        },
        {
            "img": "/app_images/events/event2.webp",
            "link": "/app/events",
            "ticket_link": "https://www.askamaya.com/events/tickets",
            "badgeDate": "12 Mar",
            "badgeYear": "2024",
            "location": "Eko Hotel",
            "time": "8:00 am - 5:00 pm",
            "title": "Most effective ways Education's Problem.",
        },
        {
            "img": "/app_images/events/event3.webp",
            "link": "/app/events",
            "ticket_link": "https://www.askamaya.com/events/tickets",
            "badgeDate": "11 Oct",
            "badgeYear": "2024",
            "location": "Emirate",
            "time": "8:00 am - 5:00 pm",
            "title": "Top 7 Common About Education.",
        },
        {
            "img": "/app_images/events/event4.webp",
            "link": "/app/events",
            "ticket_link": "https://www.askamaya.com/events/tickets",
            "badgeDate": "16 May",
            "badgeYear": "2024",
            "location": "Vancouver",
            "time": "8:00 am - 5:00 pm",
            "title": "Tech Crunch Software Festival 2024",
        },
        {
            "img": "/app_images/events/event5.webp",
            "link": "/app/events",
            "ticket_link": "https://www.askamaya.com/events/tickets",
            "badgeDate": "4 Jul",
            "badgeYear": "2024",
            "location": "IAC Building",
            "time": "8:00 am - 5:00 pm",
            "title": "AI and Auitomation Fair, 2024",
        },
        {
            "img": "/app_images/events/event6.webp",
            "link": "/app/events",
            "ticket_link": "https://www.askamaya.com/events/tickets",
            "badgeDate": "20 Dec",
            "badgeYear": "2024",
            "location": "Paris",
            "time": "8:00 am - 5:00 pm",
            "title": "Integrated blockchain Conference",
        }
        
    ]
      

};